import React, { useState } from "react";
import { Search } from "lucide-react";
import ResponsiveSearchBarDropdown from "./ResponsiveSearchBarDropdown";

export default function SearchHeroMobile({
  searchQuery,
  setSearchQuery,
  onSearch,
}) {
  const [searchOpen, setSearchOpen] = useState(false);

  const styles = {
    section: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",

 paddingTop: "34px",
      paddingBottom: "22px",

  overflow: "visible",

      width: "100%",
    },

    dividerRow: {
      display: "flex",
      alignItems: "center",

      width: "100%",

      padding: "0 16px",

      boxSizing: "border-box",

      gap: "14px",

   marginBottom: "18px",
    },

    line: {
      flex: 1,

      height: "1px",

   background: "rgba(0,0,0,0.06)",
    },

    brand: {
      fontSize: "56px",

      fontWeight: 300,

 letterSpacing: "6px",

      lineHeight: 0.9,

      textTransform: "uppercase",

      color: "#B0B0B7",

      fontFamily:
        "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'SF Pro Display', sans-serif",

      textShadow:
        "0 1px 0 rgba(255,255,255,0.7)",

      opacity: 0.92,

      whiteSpace: "nowrap",

      WebkitFontSmoothing: "antialiased",

      transform: "translateY(-2px)",
    },



searchWrap: {
  position: "relative",

  width: "100%",

  padding: "0 16px",

  boxSizing: "border-box",

  overflow: "visible",

  zIndex: 9999,
},

 searchBar: {
  position: "relative",

  zIndex: 10001,

  width: "100%",

maxWidth: "100%",

  boxSizing: "border-box",

  display: "flex",
  alignItems: "center",

  gap: "12px",

  padding: "13px 18px",

  borderRadius: searchOpen
    ? "24px 24px 0 0"
    : "24px",

  marginBottom: "0",

  transition: "all 0.22s ease",

  background: "rgba(255,255,255,0.52)",

  backdropFilter: "blur(24px) saturate(180%)",
  WebkitBackdropFilter:
    "blur(24px) saturate(180%)",

  border: searchOpen
    ? "1px solid rgba(255,255,255,0.45)"
    : "1px solid rgba(255,255,255,0.45)",

  borderBottom: searchOpen
    ? "none"
    : "1px solid rgba(255,255,255,0.45)",

  boxShadow:
    "0 6px 18px rgba(0,0,0,0.06), \
     inset 0 1px 0 rgba(255,255,255,0.75)",
},




    icon: {
      opacity: 0.48,

      flexShrink: 0,

      cursor: "pointer",
    },

    input: {
      flex: 1,

      border: "none",
      outline: "none",

      background: "transparent",

      fontSize: "16px",

      fontWeight: 400,

      color: "#1D1D1F",

      fontFamily:
        "-apple-system, BlinkMacSystemFont, 'SF Pro Text', Inter, system-ui",
    },
  };

  return (
    <section style={styles.section}>
      {/* ELEVEN + DIVIDERS */}
      <div style={styles.dividerRow}>
        <div style={styles.line}></div>

        <div style={styles.brand}>
          ELEVEN
        </div>

        <div style={styles.line}></div>
      </div>

      {/* SEARCH */}
      <div style={styles.searchWrap}>
        <div style={styles.searchBar}>
          <Search
            size={19}
            strokeWidth={2}
            style={styles.icon}
            onClick={onSearch}
          />

       <input
  style={styles.input}
  placeholder="Try Seadoo GTX 300 IBR ...."
  value={searchQuery}
  onClick={() => setSearchOpen(true)}
  onFocus={() => {
    setTimeout(() => {
      setSearchOpen(true);
    }, 50);
  }}
  onChange={(e) =>
    setSearchQuery(e.target.value)
  }
  onKeyDown={(e) => {
    if (e.key === "Enter") onSearch();
  }}
/>
        </div>

 <ResponsiveSearchBarDropdown
          open={searchOpen}
          onClose={() => setSearchOpen(false)}
          query={searchQuery}
          onSearch={(q) => {
            setSearchQuery(q);
            onSearch(q);
          }}
        />
      </div>
    </section>
  );
}